import React from 'react'
import { Link } from 'react-router-dom'
import { Badge, Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faEnvelopeOpenText, faHourglassHalf, faTools } from '@fortawesome/free-solid-svg-icons'

const NEXT_STEPS = [
  {
    icon: faEnvelopeOpenText,
    text: (email) => (
      <>
        Confirma tu correo con el enlace que te enviamos a <b>{email}</b>. Sin ese paso no podrás iniciar sesión.
      </>
    )
  },
  {
    icon: faHourglassHalf,
    text: () => 'El equipo de Homelan revisará tus documentos. Verás el estado de la verificación al entrar a tu panel.'
  },
  {
    icon: faTools,
    text: () => 'Mientras tanto ya puedes cargar tus servicios: se mostrarán en el Marketplace cuando aprobemos tu perfil.'
  }
]

const ProviderRegisterSuccess = ({ email }) => (
  <div className="text-center py-3">
    <FontAwesomeIcon icon={faCheckCircle} size="3x" className="text-success mb-3" />
    <h4 className="mb-2">¡Recibimos tu registro!</h4>
    <p className="mb-4">
      Tu perfil quedó <Badge color="soft-warning" pill>Pendiente de verificación</Badge>
    </p>
    <div className="text-left mx-auto mb-4" style={{ maxWidth: 460 }}>
      {NEXT_STEPS.map((step, index) => (
        <div key={index} className="d-flex mb-3">
          <FontAwesomeIcon icon={step.icon} className="text-primary mt-1 mr-3 flex-shrink-0" />
          <p className="mb-0 fs--1 text-700">{step.text(email)}</p>
        </div>
      ))}
    </div>
    <Button tag={Link} to="/authentication/login" color="primary" className="px-5">
      Ir a iniciar sesión
    </Button>
  </div>
)

export default ProviderRegisterSuccess
